/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { createAction, props } from '@ngrx/store';

export const incLoading = createAction('[Progress Bar] + Loading', props<{ key: string }>());
export const decLoading = createAction('[Progress Bar] - Loading', props<{ key: string; force?: boolean }>());
